import styled, { AnyStyledComponent, css } from 'styled-components';

import shapes from '../../../assets/styled/shapes';

import CoreCell from '../../NewTable/_common/CoreCell';
import CoreRow from '../../NewTable/_common/CoreRow';
import Controller from '../Controller';

interface Theme {
  invalid?: boolean;
  disabled?: boolean;
  triangle?: boolean;
}

export interface OutlineProps {
  inputComponent: AnyStyledComponent;
  theme: Theme;
}

const createBorders = (type = 'default', size = 8) => css`
  border: ${Controller.styles.borders[type]};

  /* Triangle */
  &::after {
    ${shapes.bottomRightTriangle(size, Controller.styles.borderColors[type])}
  }
`;

const Outline = styled.div<OutlineProps>`
  ${shapes.absoluteFullSize(-1)}
  ${createBorders()}

  border-style: none dotted;
  pointer-events: none;
  right: 0; /* Prevents overflow auto on the x axis */
  bottom: 0;

  ${CoreRow}:first-child && {
    top: 0;
  }

  ${CoreCell}:first-child && {
    left: 0;
  }

  /* Triangle */
  ${({ theme }) =>
    theme.triangle &&
    css`
      &::after {
        content: '';
      }
    `}

  /* Invalid */
  ${({ theme }) =>
    theme.invalid &&
    !theme.disabled &&
    css`
      /* Adds red borders to outlines in all cells, including last one */
      &&,
      ${CoreCell}:last-child && {
        ${createBorders('error')}
      }

      z-index: 1; /* Overlays surrounding borders */
    `}

  /* Enabled */
  ${({ theme, inputComponent }) =>
    !theme.disabled &&
    css`
      /* Hover state */
      ${CoreCell}:hover &&,
      ${inputComponent}:hover ~ && {
        ${createBorders(theme.invalid ? 'errorFocus' : 'hover', 12)}
        z-index: 1; /* Overlays surrounding borders */
      }

      /* Focus state */
      ${inputComponent}:focus-within ~ && {
        ${createBorders(theme.invalid ? 'errorFocus' : 'focus', 12)}
        z-index: 1; /* Overlays surrounding borders */
      }
    `}
`;

export default Outline;
